import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";

// Load Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

let app, auth, db, googleProvider, facebookProvider;

// We initialize Firebase conditionally so that the local dev environment
// does not crash if you haven't added the .env config yet.
try {
  if (firebaseConfig.apiKey) {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    googleProvider = new GoogleAuthProvider();
    facebookProvider = new FacebookAuthProvider();
  }
} catch (error) {
  console.error("Firebase Initialization Error:", error);
}

export const signInWithGoogle = async () => {
  if (!auth) throw new Error("Firebase is not configured. Please add your credentials to a .env.local file.");
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    console.error("Google Sign-In Error:", error);
    throw error;
  }
};

export const signInWithFacebook = async () => {
  if (!auth) throw new Error("Firebase is not configured. Please add your credentials to a .env.local file.");
  try {
    const result = await signInWithPopup(auth, facebookProvider);
    return result.user;
  } catch (error) {
    console.error("Facebook Sign-In Error:", error);
    throw error;
  }
};

export const saveGameStateToCloud = async (userId, gameState) => {
  if (!db) return; 
  try {
    const docRef = doc(db, "users", userId);
    
    // Deep copy and flatten grid for Firestore (no nested arrays)
    const stateToSave = JSON.parse(JSON.stringify(gameState));
    if (stateToSave.map && stateToSave.map.grid) {
      stateToSave.map.grid = stateToSave.map.grid.flat();
    }
    
    await setDoc(docRef, { gameState: stateToSave }, { merge: true });
  } catch (error) {
    console.error("Error saving game state to cloud:", error);
  }
};

export const loadGameStateFromCloud = async (userId) => {
  if (!db) return null;
  try {
    const docRef = doc(db, "users", userId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data().gameState;
      // Reconstitute 2D grid from flat array
      if (data.map && data.map.grid && Array.isArray(data.map.grid)) {
        const flat = data.map.grid;
        if (flat.length === 225) { // 15x15
          const grid = [];
          for (let i = 0; i < 225; i += 15) {
            grid.push(flat.slice(i, i + 15));
          }
          data.map.grid = grid;
        }
      }
      return data;
    }
  } catch (error) {
    console.error("Error loading game state from cloud:", error);
  }
  return null;
};
